<style lang="scss" scoped>
.wgt-content-part {

  // 沉浸式模式下启用 grid 布局，让 header 和 body 叠加
  &.immersive-mode {
    display: grid;
    overflow: hidden;
    width: 100%;
    max-width: 100%;

    .content-part-header,
    .content-part-body {
      grid-area: 1 / 1 / 1 / 1;
      align-self: start;
      width: 100%;
      max-width: 100%;
      min-width: 0; // 防止 grid 子元素溢出
    }
  }

  .content-part-header {
    width: 100%;
    box-sizing: border-box;
    left: 0;
    right: 0;
    z-index: 20;

    .content-part-top-image {
      width: 100%;
      height: 31px;
      display: block;
    }

    &-inner {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;

      .content-part_h {
        &-icon {
          width: 24px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          position: absolute;
          transition: all 0.3s;

          &-l {
            left: 0px;
            z-index: 99;
          }

          &-r {
            right: 0;
          }
        }

        &-content {
          box-sizing: border-box;
          overflow-x: scroll;
          overflow-y: hidden;
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;
          scroll-snap-type: x mandatory;
          height: 100%;
          width: 100%;

          &::-webkit-scrollbar {
            display: none;
          }

          &_inner {
            width: max-content;
            min-width: 100%;
            box-sizing: border-box;
            transition: all 0.3s;
            height: auto;

            &-0 {
              width: max-content;
              width: 100%;
              display: flex;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: space-around;
              box-sizing: border-box;
              transition: all 0.3s;
              height: auto;
            }
          }

          .header-item {
            height: 100%;
            display: inline-block;

            &-0 {
              flex: 1 1 auto;
              display: flex;
              align-items: center;
              justify-content: center;

              .header-img {
                min-width: 100%;
              }
            }

            .header-img {
              width: fit-content;
              transition: all 0.3s;
              box-sizing: border-box;
              min-width: 100%;
            }
          }
        }
      }
    }
  }

  .content-part-body {
    &_two {
      overflow: hidden;
    }

    &_content {
      display: flex;
      transition: all 0.3s;

      .wgt-bd-content {
        flex-shrink: 0;
        width: 100%;
        height: fit-content;
      }
    }

  }
}
</style>


<template>
  <div :class="{ 'wgt-content-part': true, 'immersive-mode': value.immersiveSwitch == 1 }"
    :ref="`stickyElement_${value.uuid}`">
    <div class="content-part-header" :style='setOutHeaderStyle'>
      <div class="content-part-top-image" v-if="topImageUrl || topImageUrlSearch" style="display: flex; align-items: center; justify-content: center; position: relative;">
        <el-image v-if="topImageUrlSearch" :src="topImageUrlSearch" fit="cover" style="height: 100%; position: absolute; left: 0px; z-index: 1;">
          <div slot="error" class="image-slot" />
        </el-image>
        <el-image v-if="topImageUrl" :src="topImageUrl" fit="cover" style="width: 100%;">
          <div slot="error" class="image-slot" />
        </el-image>
      </div>

      <div class="content-part-header-inner" :style='setInHeaderStyle'>
        <div class="content-part_h-icon-l content-part_h-icon" @click="handleClickIcon('left')"
          v-if="(value.navsetting == 1 && value.fixsetting.leftimgUrl) || (value.navsetting == 0 && value.defaultsetting.leftimgUrl)">
          <el-image fit="contain" style="width: 24px;height: 24px;"
            :src="value.navsetting == 1 ? value.fixsetting.leftimgUrl : value.defaultsetting.leftimgUrl"
            v-show="Math.abs(transformLeft) > 40">
            <div slot="error" class="image-slot" />
          </el-image>
        </div>
        <div class="content-part_h-content" ref="content-part_h">
          <div :class="setStyleInner" ref="content-part_h-inner"
            :style="{ transform: `translateX(${transformLeft || 0}px)` }">
            <div v-for="(item, index) in value.data" :key="`content-part_h_${index}`" :id="`content-part_h_${index}`"
              :class="setNavItemClass" :style='setItemStyle(item, index)' @click="handleClickNav(index)"
              :ref="`content-part_h_${index}`">
              <!-- 非沉浸式模式 -->
              <SpImage :class="setNavClass" :src="item.navActiveIcon" :style="`height: 100%`" fit="heightFix"
                v-show="curIndex == index && value.immersiveSwitch == 0" />
              <SpImage :class="setNavClass" :src="item.navdefaultIcon" :style="`height: 100%`" fit="heightFix"
                v-show="curIndex != index && value.immersiveSwitch == 0" />
              <!-- 沉浸式模式 -->
              <span :style="setNavTextStyle(item, index)"
                v-show="value.immersiveSwitch == 1">{{ item.navItemText }}</span>
            </div>
          </div>
        </div>
        <div class="content-part_h-icon-r  content-part_h-icon" @click="handleClickIcon('right')"
          v-if="(value.navsetting == 1 && value.fixsetting.rightimgUrl) || (value.navsetting == 0 && value.defaultsetting.rightimgUrl)">
          <el-image fit="contain" style="width: 24px;height: 24px;"
            :src="value.navsetting == 1 ? value.fixsetting.rightimgUrl : value.defaultsetting.rightimgUrl"
            v-show="Math.abs(transformLeft) <= 40">
            <div slot="error" class="image-slot" />
          </el-image>
        </div>
      </div>
    </div>
    <div class="content-part-body">
      <div class="content-part-body_one" v-if="value.animate == 0">
        <div class="wgt-bd-content" v-for="(item, key) in value.data" :key="`wgt-bd-content__${key}`"
          :ref="`conetnt_${value.uuid}_${key}`">
          <component v-for="(wgt, index) in item?.cusTom?.template" :is="wgt.name" :value="wgt"
            :key="`content-part-component__${index}`" />
        </div>
      </div>
      <div class="content-part-body_two" v-if="value.animate == 1">
        <div class="content-part-body_content" @pointerdown="handleEnter"
          :style="{ 'transform': 'translateX(-' + curIndex * 375 + 'px)', 'marginLeft': margintop + 'px' }">
          <div class="wgt-bd-content" v-for="(item, key) in value.data" :key="`wgt-bd-content__${key}`"
            :ref="`conetnt_${value.uuid}_${key}`" :style="{ height: `${curIndex == key ? 'auto' : '0'}` }">
            <component v-for="(wgt, index) in item?.cusTom?.template" :is="wgt.name" :value="wgt"
              :key="`content-part-component__${index}`" />
          </div>
        </div>
      </div>
      <div class="content-part-body_three" v-if="value.animate == 2">
        <component v-for="(wgt, index) in value.data[curIndex]?.cusTom?.template" :is="wgt.name" :value="wgt"
          :key="`content-part-component__${index}`" />
      </div>
    </div>

  </div>
</template>

<script>
import config from './config'

export default {
  name: 'contentPart',
  wgtName: '内容分区',
  wgtDesc: '',
  wgtIcon: 'wgt_content-part',
  wgtType: 2,
  wgtTem: 0,//0代表微信和抖音小程序都可以配置,1代表只能配置微信
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {
      curIndex: 0,
      transformLeft: 0,
      navwidth: [],
      headerwidth: 0,
      tabwidth: 0,
      isMoused: false,
      starty: 0, //开始的位置x
      endy: 0, //结束的位置y
      critical: 100, //触发翻页的临界值
      margintop: 0, //滑动左拉距离
      height: 0,
      stickyScrollY: null, //吸顶时记录的滚动距离
      scrollTrigger: 0, //滚动触发器，用于强制更新计算属性
      cachedStickyResult: null, //缓存的吸顶检测结果
      lastScrollTrigger: -1, //上次计算时的scrollTrigger值
      scrollContainer: null, //实际的滚动容器
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 添加滚动监听
      this.handleScroll = this.throttle(() => {
        this.scrollTrigger++ // 更新触发器，让计算属性重新计算
        console.log('🚢 ~ 滚动触发，scrollTrigger:', this.scrollTrigger)
      }, 50) // 节流50ms

      // 查找实际的滚动容器
      const headerElement = this.$el?.querySelector('.content-part-header')
      if (headerElement) {
        this.scrollContainer = this.findScrollableParent(headerElement)
        console.log('🚢 ~ 滚动容器:', this.scrollContainer === window ? 'window' : this.scrollContainer)
      } else {
        this.scrollContainer = window
      }

      // 在正确的容器上添加滚动监听
      if (this.scrollContainer === window) {
        window.addEventListener('scroll', this.handleScroll, true)
      } else {
        this.scrollContainer.addEventListener('scroll', this.handleScroll, true)
      }
      console.log('🚢 ~ 滚动监听已添加到:', this.scrollContainer === window ? 'window' : 'scrollContainer')
    })
  },
  beforeDestroy() {
    // 移除滚动监听
    if (this.handleScroll) {
      if (this.scrollContainer === window) {
        window.removeEventListener('scroll', this.handleScroll, true)
      } else if (this.scrollContainer) {
        this.scrollContainer.removeEventListener('scroll', this.handleScroll, true)
      }
    }
  },
  methods: {
    // 将颜色转换为带透明度的rgba格式
    addAlphaToColor(color, alpha) {
      if (!color) return color

      // 如果已经是rgba格式，提取rgb部分
      if (color.startsWith('rgba')) {
        const rgb = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i)
        if (rgb) {
          return `rgba(${rgb[1]}, ${rgb[2]}, ${rgb[3]}, ${alpha})`
        }
      }

      // 如果是rgb格式
      if (color.startsWith('rgb')) {
        const rgb = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/i)
        if (rgb) {
          return `rgba(${rgb[1]}, ${rgb[2]}, ${rgb[3]}, ${alpha})`
        }
      }

      // 如果是hex格式 (#fff 或 #ffffff)
      if (color.startsWith('#')) {
        let hex = color.replace('#', '')
        // 转换3位hex为6位
        if (hex.length === 3) {
          hex = hex.split('').map(char => char + char).join('')
        }
        const r = parseInt(hex.substr(0, 2), 16)
        const g = parseInt(hex.substr(2, 2), 16)
        const b = parseInt(hex.substr(4, 2), 16)
        return `rgba(${r}, ${g}, ${b}, ${alpha})`
      }

      // 其他格式直接返回
      return color
    },

    // 查找可滚动的父元素
    findScrollableParent(element) {
      let parent = element.parentElement
      while (parent) {
        const overflowY = window.getComputedStyle(parent).overflowY
        const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden'
        if (isScrollable && parent.scrollHeight > parent.clientHeight) {
          console.log('🚢 ~ 找到可滚动父元素:', parent, 'scrollTop:', parent.scrollTop)
          return parent
        }
        parent = parent.parentElement
      }
      return window
    },

    // 节流函数
    throttle(func, wait) {
      let timeout
      return function (...args) {
        if (!timeout) {
          timeout = setTimeout(() => {
            timeout = null
            func.apply(this, args)
          }, wait)
        }
      }
    },

    // 检测 content-part-header 是否已经吸顶
    checkIsSticky() {
      const headerElement = this.$el?.querySelector('.content-part-header')
      if (!headerElement) {
        return false
      }

      const rect = headerElement.getBoundingClientRect()
      console.log("🚢 ~ 当前打印的内容 ~ rect.top:", rect.top);
      // 当元素距离视口顶部 <= 65px 时，说明已经吸顶（考虑页面结构的65px偏移）
      const isSticky = rect.top <= 65

      // 如果刚刚吸顶，记录当前滚动位置
      if (isSticky && this.stickyScrollY === null) {
        // 记录吸顶时的滚动位置，用于后续计算滑动距离
        this.stickyScrollY = window.pageYOffset || document.documentElement.scrollTop
        console.log('🚢 ~ 吸顶时记录的滚动位置:', this.stickyScrollY, 'rect.top:', rect.top)
      }

      // 如果不再吸顶，清除记录
      if (!isSticky && this.stickyScrollY !== null) {
        this.stickyScrollY = null
        console.log('🚢 ~ 已离开吸顶状态，清除记录')
      }

      console.log('🚢 ~ content-part-header 是否吸顶:', isSticky, 'rect.top:', rect.top)
      return isSticky
    },

    // 检测吸顶后滑动距离是否超过100
    checkStickyScrollDistance() {
      // 如果在同一个计算周期内（scrollTrigger相同），直接返回缓存结果
      // 注意：只有当scrollTrigger > 0时才使用缓存（避免初始状态被缓存）
      if (this.lastScrollTrigger === this.scrollTrigger && this.cachedStickyResult !== null && this.scrollTrigger > 0) {
        console.log('🚢 ~ 使用缓存结果', this.cachedStickyResult)
        return this.cachedStickyResult
      }

      // 更新scrollTrigger标记
      this.lastScrollTrigger = this.scrollTrigger

      console.log('🚢 ~ 开始新的计算，scrollTrigger:', this.scrollTrigger)

      const headerElement = this.$el?.querySelector('.content-part-header')
      if (!headerElement) {
        const result = {
          isSticky: false,
          exceedThreshold: false,
          distance: 0
        }
        this.cachedStickyResult = result
        return result
      }

      const rect = headerElement.getBoundingClientRect()
      // 考虑65px的偏移，当 rect.top <= 65 时为吸顶状态
      const isSticky = rect.top <= 65

      console.log('🚢 ~ 【检测】rect.top:', rect.top, '是否吸顶:', isSticky, '记录的起始位置:', this.stickyScrollY)

      // 如果不是吸顶状态，返回初始状态并清除记录
      if (!isSticky) {
        // 不在吸顶状态时，清除记录
        if (this.stickyScrollY !== null) {
          console.log('🚢 ~ 已离开吸顶状态，清除记录，之前的值:', this.stickyScrollY)
          this.stickyScrollY = null
        }
        const result = {
          isSticky: false,
          exceedThreshold: false,
          distance: 0
        }
        this.cachedStickyResult = result
        return result
      }

      // 在吸顶状态下，获取滚动位置
      // 尝试多种方式获取滚动位置
      let currentScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0

      // 如果上面的值都是0，尝试从元素位置反推滚动距离
      if (currentScrollY === 0 && rect.top < 1000) {
        // 使用元素的 getBoundingClientRect 反推
        // 如果元素在视口顶部65px位置，说明页面已经滚动了 (元素原始位置 - 65)
        const scrollableParent = this.findScrollableParent(headerElement)
        if (scrollableParent && scrollableParent !== window) {
          currentScrollY = scrollableParent.scrollTop || 0
          console.log('🚢 ~ 使用父容器的scrollTop:', currentScrollY)
        }
      }

      console.log('🚢 ~ 当前滚动位置:', currentScrollY, 'window.pageYOffset:', window.pageYOffset, 'scrollTop:', document.documentElement.scrollTop)

      // 如果还没记录起始位置，先记录（只在第一次吸顶时记录）
      if (this.stickyScrollY === null) {
        this.stickyScrollY = currentScrollY
        console.log('🚢 ~ 首次吸顶，记录滚动位置:', this.stickyScrollY, 'rect.top:', rect.top)
        // 首次记录时距离为0
        const result = {
          isSticky: true,
          exceedThreshold: false,
          distance: 0
        }
        this.cachedStickyResult = result
        return result
      }

      // 计算当前滚动位置与吸顶时位置的差值
      const distance = Math.abs(currentScrollY - this.stickyScrollY)
      const exceedThreshold = distance > 100

      console.log('🚢 ~ 【计算结果】滑动距离:', distance, '超过100:', exceedThreshold, '【详情】当前位置:', currentScrollY, '起始位置:', this.stickyScrollY, 'rect.top:', rect.top)

      const result = {
        isSticky: true,
        exceedThreshold: exceedThreshold,
        distance: distance
      }
      this.cachedStickyResult = result
      return result
    },
    handleClickNav(indx) {
      this.curIndex = indx
      let transformLeft = 0
      const inner = this.$refs[`content-part_h`].offsetWidth;
      for (let index = 0; index <= indx + 1; index++) {
        const item = this.$refs[`content-part_h_${index}`];
        if (item) {
          transformLeft = transformLeft + item[0]?.offsetWidth || 0
        }
      }

      if (inner - transformLeft >= -2) {
        this.transformLeft = 0
        return
      }
      this.transformLeft = inner - transformLeft + 2
    },
    handleClickIcon(type) {
      if (type == 'left') {
        this.transformLeft = 0
        return
      }
      if (type == 'right') {
        let transformLeft = 0
        const inner = this.$refs[`content-part_h`].offsetWidth;
        for (let index = 0; index < this.value.data.length; index++) {
          const item = this.$refs[`content-part_h_${index}`][0];
          transformLeft = transformLeft + Math.floor(item.offsetWidth)
        }
        this.transformLeft = inner - transformLeft
      }
    },
    handleEnter(e) {
      this.isMoused = true
      this.starty = e.pageX
    },
    handleMove(e) {
      if (!this.isMoused) return
      let px = e.pageY;
      this.endy = px;
      if (px - this.starty < 100 && px - this.starty > -100) {
        this.margintop = px - this.starty;
      }

    },
    handleLeaves(e) {
      if (this.endy - this.starty > 100 && this.curIndex > 0) {
        this.curIndex--;
      } else if (this.endy - this.starty < -100 && this.curIndex < this.value.data.length - 1) {
        this.curIndex++;
      }
      this.starty = 0;
      this.endy = 0;
      this.margintop = 0;
      this.isMoused = false
      let transformLeft = 0
      if (this.curIndex > 1) {
        for (let index = 0; index < this.curIndex - 1; index++) {
          let width = this.navwidth[index]
          transformLeft -= width
        }
        if (transformLeft >= this.headerwidth - this.tabwidth) {
          this.transformLeft = transformLeft
        }
      }
    },
    setItemStyle(item, index) {
      const { navsetting, fixsetting, defaultsetting } = this.value
      const { navActiveColor, otherColor } = this.value.data[this.curIndex] || {}
      const { slideritempadded: { paddedtb, paddedlr }, navitemHeight } = navsetting == 1 ? fixsetting : defaultsetting
      return {
        padding: `${paddedtb || 0}px ${paddedlr || 0}px`,
        backgroundColor: this.curIndex == index ? navActiveColor : otherColor,
        height: `${navitemHeight || 24}px`,
        lineHeight: `${navitemHeight || 24}px`
      }
    },
    // 设置沉浸式导航项文本样式
    setNavTextStyle(item, index) {
      const { defaultsetting } = this.value
      const { navitemtextfontsize, navitemtextboldvalue } = defaultsetting
      const isActive = this.curIndex == index

      // 根据是否滑动后选择对应的颜色
      let textColor
      if (isActive) {
        // 当前项是选中项：保持原有逻辑，使用激活颜色
        textColor = this.isScrollExceed && item.textActiveColorSlider
          ? item.textActiveColorSlider
          : item.textActiveColor
      } else {
        // 当前项不是选中项的颜色逻辑：
        // - 滑动状态：使用自己的 textDefaultColorSlider（保持原逻辑）
        // - 非滑动状态：使用选中项的 textDefaultColor（新需求）

        if (this.isScrollExceed && item.textDefaultColorSlider) {
          // 滑动超出时：使用非选中项自己的滑动颜色（保持原有逻辑）
          textColor = item.textDefaultColorSlider
        } else {
          // 非滑动状态时：使用选中项的默认颜色（新需求：所有非选中项跟随选中项的颜色）
          const selectedItem = this.value.data[this.curIndex] || {} // 获取选中项的数据
          const { textDefaultColor: selectedItemDefaultColor } = selectedItem // 获取选中项的默认颜色

          console.log("🚢 ~ 非选中项使用选中项的颜色 ~ selectedItemDefaultColor:", selectedItemDefaultColor);

          textColor = selectedItemDefaultColor
        }
      }

      return {
        color: textColor,
        fontSize: `${navitemtextfontsize}px`,
        fontWeight: isActive ? navitemtextboldvalue : 400 // 选中时加粗，未选中时正常字重
      }
    },
    svgToDataURL(svgStr) {
      if (!svgStr || typeof svgStr !== 'string') {
        alert('请输入有效的SVG代码！');
        return '';
      }
      // 步骤1：清理多余空白（减少URL长度）
      const cleanSvg = svgStr
        .replace(/\s+/g, ' ')       // 多个空白替换为单个空格
        .replace(/>\s+</g, '><')    // 标签之间的空白直接移除
        .trim();
      // 步骤2：转义特殊字符（避免URL解析错误）
      const escapedSvg = cleanSvg
        .replace(/#/g, '%23')       // # 转义
        .replace(/&/g, '%26')       // & 转义
        .replace(/"/g, '%22')       // " 转义
        .replace(/'/g, '%27')       // ' 转义
        .replace(/</g, '%3C')       // < 转义
        .replace(/>/g, '%3E');      // > 转义
      // 步骤3：拼接Data URL前缀
      const dataUrl = `data:image/svg+xml;utf8,${escapedSvg}`;
      return dataUrl;
    },
    updateSvgColor(colorMode, topimgUrlSvg) {
      // 判断颜色模式
      const encodedColor = colorMode == 'light' ? '#ffffff' : '#000000'

      // 使用正则表达式匹配所有 fill="#([A-Fa-f0-9]{3,6})" 后面的颜色值（支持3位和6位颜色）
      const fillPattern = /fill="#([A-Fa-f0-9]{3,6})"/g

      let count = 0
      // 先在新变量中处理字符串替换
      const newSvgInfo = topimgUrlSvg.replace(fillPattern, (match, color) => {
        count++
        // 跳过第一个，从第二个开始替换
        // if (count === 1) {
        //   return match
        // }
        return `fill="${encodedColor}"`
      })
      return newSvgInfo
    }
  },
  computed: {
    // 是否超过滚动阈值（仅当navsetting=1时才判断）
    isScrollExceed() {
      this.scrollTrigger
      const { immersiveSwitch } = this.value
      if (immersiveSwitch != 1) return false

      const { exceedThreshold } = this.checkStickyScrollDistance()
      return exceedThreshold
    },
    // 顶部图片URL
    topImageUrl() {
      this.scrollTrigger
      const { immersiveSwitch, defaultsetting } = this.value
      if (immersiveSwitch == 0) return ''
      const { topimgUrlSvg, immersiveSwitchColorMode } = defaultsetting

      if (topimgUrlSvg) {
        const { colorMode = 'dark' } = this.value.data[this.curIndex] || {}
        // 滑动后使用 immersiveSwitchColorMode，否则使用 colorMode
        const actualColorMode = this.isScrollExceed ? (immersiveSwitchColorMode || 'dark') : colorMode
        const newSvgInfo = this.updateSvgColor(actualColorMode, topimgUrlSvg)
        const dataUrl = this.svgToDataURL(newSvgInfo)
        return dataUrl
      }
      return ''
    },
    // 顶部搜索图片URL
    topImageUrlSearch() {
      this.scrollTrigger
      const { immersiveSwitch, defaultsetting } = this.value
      if (immersiveSwitch == 0) return ''
      const { topimgUrlSvgSearch, immersiveSwitchColorMode } = defaultsetting

      if (topimgUrlSvgSearch) {
        const { colorMode = 'dark' } = this.value.data[this.curIndex] || {}
        // 滑动后使用 immersiveSwitchColorMode，否则使用 colorMode
        const actualColorMode = this.isScrollExceed ? (immersiveSwitchColorMode || 'dark') : colorMode
        const newSvgInfo = this.updateSvgColor(actualColorMode, topimgUrlSvgSearch)
        const dataUrl = this.svgToDataURL(newSvgInfo)
        return dataUrl
      }
      return ''
    },
    setOutHeaderStyle() {
      this.scrollTrigger

      const { navsetting, fixsetting, defaultsetting, fixedTop, immersiveSwitch } = this.value
      const setting = navsetting == 1 ? fixsetting : defaultsetting
      const { navbgtype, navbgcolor, imgUrl, navpadded: { paddedt, paddedb, paddedl, paddedr }, navbgslidervalue, navbgopacity } = setting
      const position = fixedTop == 1 ? 'sticky' : 'static'

      // 只有immersiveSwitch=1时才使用滑动后的样式
      const useSliderStyle = immersiveSwitch == 1 && this.isScrollExceed

      let bgStyle = {}
      let bgColor = useSliderStyle ? navbgslidervalue : navbgcolor
      // 滑动后添加透明度
      if (useSliderStyle) {
        bgColor = this.addAlphaToColor(bgColor, navbgopacity)
      }

      // 背景类型为颜色
      if (navbgtype == 0) {
        bgStyle = { 'background-color': bgColor }
      }
      // 背景类型为图片
      else if (navbgtype == 1) {
        bgStyle = {
          'background-image': `url(${imgUrl})`,
          'background-size': '100% 100%',
          'background-position': 'center top',
          'background-repeat': 'no-repeat',
        }
      }

      // 滑动后添加毛玻璃效果
      let glassStyle = {}
      if (useSliderStyle) {
        glassStyle = {
          'background-color': bgColor,
          '-webkit-backdrop-filter': 'blur(8px) saturate(220%) brightness(0.9)',
          'backdrop-filter': 'blur(8px) saturate(220%) brightness(0.9)'
        }
      }

      return {
        position,
        padding: `${immersiveSwitch == 1 ? 27 : paddedt || 0}px ${paddedr || 0}px ${paddedb || 0}px ${paddedl || 0}px`,
        top: '0px',
        ...bgStyle,
        ...glassStyle
      }
    },
    setInHeaderStyle() {
      this.scrollTrigger

      const { navsetting, fixsetting, defaultsetting, immersiveSwitch } = this.value
      const setting = navsetting == 1 ? fixsetting : defaultsetting
      const { navitemcolor, navitemHeight, navitemradius, navitemareapadded, navitemcolorSlider } = setting
      const { paddedt = 0, paddedb = 0, paddedl = 0, paddedr = 0 } = navitemareapadded || {}

      // 只有immersiveSwitch=1时才使用滑动后的颜色
      const useSliderStyle = immersiveSwitch == 1 && this.isScrollExceed
      const backgroundColor = useSliderStyle && navitemcolorSlider ? navitemcolorSlider : navitemcolor

      return {
        'background-color': backgroundColor,
        'border-radius': `${navitemradius || 0}px`,
        height: `${navitemHeight || 24}px`,
        padding: `${paddedt}px ${paddedr}px ${paddedb}px ${paddedl}px`
      }
    },
    setBgcolor() {
      const { navsetting, fixsetting, defaultsetting } = this.value
      const setting = navsetting == 1 ? fixsetting : defaultsetting
      return {
        backgroundColor: this.value.data[this.curIndex].otherColor,
        height: `${setting.navitemHeight || 24}px`
      }
    },

    setNavClass() {
      const { navsetting, fixsetting, defaultsetting } = this.value
      const { navtype } = navsetting == 1 ? fixsetting : defaultsetting
      return navtype == 0 ? 'header-img' : 'header-img-0'
    },

    setNavItemClass() {
      const { navsetting, fixsetting, defaultsetting } = this.value
      const { navtype } = navsetting == 1 ? fixsetting : defaultsetting
      return navtype == 0 ? 'header-item' : 'header-item-0'
    },

    setStyleInner() {
      const { navsetting, fixsetting, defaultsetting } = this.value
      const { navtype } = navsetting == 1 ? fixsetting : defaultsetting
      return navtype == 0 ? 'content-part_h-content_inner' : 'content-part_h-content_inner-0'
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.transformLeft = 0
        this.curIndex = 0
      },
      deep: true,
      immediate: true
    },
  }
}
</script>
